import { GridSortModel } from "@mui/x-data-grid-pro";
import dayjs, { Dayjs } from "dayjs";
import { createContext, ReactElement, useState } from "react";
import { dayJSFormatterForAPI } from "../../../utils";
import { AllClaimsFilter } from "../../components/allClaimsGrid/AllClaimsGrid";

export type AllClaimsContextProps = {
  setAllClaimsContext: (value: AllClaimsContextState) => void;
  getAllClaimsContext: () => AllClaimsContextState;
};

export type AllClaimsContextState = {
  filter: AllClaimsFilter;
  tabIndex: number;
  pageNumber: number;
  pageSize: number;
  sortModel: GridSortModel;
};

export const AllClaimsContext = createContext({} as AllClaimsContextProps);

export const AllClaimsProvider = ({ children }: { children: ReactElement }) => {
  const currentDate: Dayjs = dayjs();
  const [claimState, setClaimState] = useState<AllClaimsContextState>({
    filter: {
      startDate: dayJSFormatterForAPI(currentDate.subtract(1, "year")),
      endDate: dayJSFormatterForAPI(currentDate),
    },
    sortModel: [{ field: "createdDate", sort: "desc" }],
    pageNumber: 0,
    pageSize: 10,
    tabIndex: 0,
  });

  const setAllClaimsContext = (value: AllClaimsContextState) => {
    setClaimState(value);
  };

  const getAllClaimsContext = (): AllClaimsContextState => claimState;

  return (
    <AllClaimsContext.Provider
      value={{
        setAllClaimsContext,
        getAllClaimsContext,
      }}
    >
      {children}
    </AllClaimsContext.Provider>
  );
};
